/**
 * Product reviews section: opens and closes the "Write a review" dialog, shows customer photos
 * in a lightbox, reveals more reviews, and lets visitors mark a review as helpful. Votes are remembered in the visitor's own browser
 * only (there is no review server), so each visitor sees their own vote. Runs once per page.
 */
(function () {
  if (window.__productReviews) return;
  window.__productReviews = true;

  var STORAGE_PREFIX = 'prv-vote:';

  function readVote(key) {
    try {
      return window.localStorage.getItem(STORAGE_PREFIX + key);
    } catch (error) {
      return null;
    }
  }

  function writeVote(key, value) {
    try {
      if (value) {
        window.localStorage.setItem(STORAGE_PREFIX + key, value);
      } else {
        window.localStorage.removeItem(STORAGE_PREFIX + key);
      }
    } catch (error) {
      /* Storage unavailable (private mode): the vote still shows until the page reloads. */
    }
  }

  function renderVotes(group, vote) {
    group.querySelectorAll('.prv-vote').forEach(function (button) {
      var pressed = button.dataset.vote === vote;
      var count = parseInt(button.dataset.count, 10) || 0;
      if (pressed) count += 1;
      button.setAttribute('aria-pressed', pressed ? 'true' : 'false');
      button.querySelector('.prv-vote__count').textContent = count > 0 ? count : '';
    });
  }

  function openDialog(dialog) {
    if (!dialog) return;
    if (typeof dialog.showModal === 'function') {
      if (!dialog.open) dialog.showModal();
    } else {
      dialog.setAttribute('open', '');
    }
    var firstField = dialog.querySelector('.prv-rate__input');
    if (firstField) firstField.focus({ preventScroll: true });
  }

  function closeDialog(dialog) {
    if (!dialog) return;
    if (typeof dialog.close === 'function' && dialog.open) {
      dialog.close();
    } else {
      dialog.removeAttribute('open');
    }
  }

  function setup(root) {
    (root || document).querySelectorAll('[data-review-vote]').forEach(function (group) {
      renderVotes(group, readVote(group.dataset.reviewVote));
    });

    (root || document).querySelectorAll('.prv-dialog[data-open-on-load]').forEach(function (dialog) {
      dialog.removeAttribute('data-open-on-load');
      openDialog(dialog);
    });

    if (/[?&]contact_posted=true/.test(window.location.search)) {
      var notice = (root || document).querySelector('.prv__notice');
      if (notice) notice.scrollIntoView({ block: 'center' });
    }
  }

  document.addEventListener('click', function (event) {
    var opener = event.target.closest('[data-review-open]');
    if (opener) {
      openDialog(document.getElementById(opener.dataset.reviewOpen));
      return;
    }

    var closer = event.target.closest('[data-review-close]');
    if (closer) {
      closeDialog(closer.closest('.prv-dialog'));
      return;
    }

    // A click on the dark backdrop lands on the dialog element itself.
    if (event.target.classList && event.target.classList.contains('prv-dialog')) {
      closeDialog(event.target);
      return;
    }

    var photo = event.target.closest('[data-review-photo]');
    if (photo) {
      var lightbox = photo.closest('.prv').querySelector('[data-review-lightbox]');
      if (lightbox && typeof lightbox.showModal === 'function') {
        event.preventDefault();
        var img = lightbox.querySelector('.prv-lightbox__img');
        img.src = photo.href;
        img.alt = photo.getAttribute('aria-label') || '';
        lightbox.showModal();
      }
      return;
    }

    if (event.target.closest('[data-review-lightbox-close]') || (event.target.matches && event.target.matches('[data-review-lightbox]'))) {
      var box = event.target.closest('[data-review-lightbox]');
      if (box) box.close();
      return;
    }

    var more = event.target.closest('[data-review-show-more]');
    if (more) {
      var list = document.getElementById(more.dataset.reviewShowMore);
      var hidden = list ? list.querySelectorAll('[data-review-more][hidden]') : [];
      var step = parseInt(more.dataset.step, 10) || 4;
      for (var i = 0; i < hidden.length && i < step; i++) {
        hidden[i].hidden = false;
      }
      if (hidden.length) {
        // Move focus to the first newly shown review so keyboard users continue from there.
        hidden[0].setAttribute('tabindex', '-1');
        hidden[0].focus({ preventScroll: true });
      }
      if (hidden.length <= step) more.closest('.prv__more').remove();
      return;
    }

    var voteButton = event.target.closest('.prv-vote');
    if (voteButton) {
      var group = voteButton.closest('[data-review-vote]');
      var key = group.dataset.reviewVote;
      var vote = readVote(key) === voteButton.dataset.vote ? null : voteButton.dataset.vote;
      writeVote(key, vote);
      renderVotes(group, vote);
    }
  });

  // The star rating is required; the radios are visually hidden, so show our own message.
  document.addEventListener(
    'invalid',
    function (event) {
      var input = event.target;
      if (!input.classList || !input.classList.contains('prv-rate__input')) return;
      event.preventDefault();
      var error = input.closest('.prv-form__rating').querySelector('[data-rating-error]');
      if (error) error.hidden = false;
    },
    true
  );

  document.addEventListener('change', function (event) {
    if (!event.target.classList || !event.target.classList.contains('prv-rate__input')) return;
    var error = event.target.closest('.prv-form__rating').querySelector('[data-rating-error]');
    if (error) error.hidden = true;
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      setup();
    });
  } else {
    setup();
  }

  document.addEventListener('shopify:section:load', function (event) {
    setup(event.target);
  });
})();
